/** @jsx jsx */
import { Dialog } from '@datacamp/waffles/dialog';
import { Paragraph } from '@datacamp/waffles/paragraph';
import { jsx } from '@emotion/react';
import React from 'react';

import largerScreenPng from '../../assets/images/larger_screen.png';
import List from '../List';

import GuidesBackButton from './GuidesBackButton';

const MakeScreenLargerModal: React.FC = () => {
  return (
    <>
      <Dialog.Header>Making the screen larger</Dialog.Header>
      <Dialog.Body>
        <Paragraph>
          Depending on the size of your computer screen, the content in the
          Virtual Machine might be too small to read or interact with. There are
          ways to make it bigger.
        </Paragraph>
        <List ordered>
          <List.Item>
            Collapse the instructions pane by clicking the arrow in the
            upper-right corner.
          </List.Item>
          <List.Item>
            Use the full-screen button in the bottom right corner to make the
            learning environment bigger.
          </List.Item>
          <List.Item>
            Use the Zoom buttons in the bottom right corner to zoom in and out.
          </List.Item>
        </List>
        <img
          alt="larger screen"
          height="auto"
          src={largerScreenPng}
          style={{ marginTop: 16 }}
          width="100%"
        />
      </Dialog.Body>
      <Dialog.Footer>
        <GuidesBackButton />
      </Dialog.Footer>
    </>
  );
};

export default MakeScreenLargerModal;
